import { render, staticRenderFns } from "./dashboard-overview.vue?vue&type=template&id=4109f130&scoped=true&"
import script from "./dashboard-overview.vue?vue&type=script&lang=js&"
export * from "./dashboard-overview.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-overview.vue?vue&type=style&index=0&id=4109f130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109f130",
  null
  
)

export default component.exports